import { render, staticRenderFns } from "./ComponentAPPDetail.vue?vue&type=template&id=7d70ea2f"
import script from "./ComponentAPPDetail.vue?vue&type=script&lang=js"
export * from "./ComponentAPPDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports